import { Button } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useDialog } from "lib/@hooks/useDialog"
import { useDemand } from "lib/authorization/use-demand"
import { errorSnackbar } from "lib/snackbar/error-snackbar"
import { successSnackbar } from "lib/snackbar/success-snackbar"
import Iconify from "minimals-template/components/Iconify"
import { ProjectPhase } from "authoring/lib/enum/project-phase.mjs"
import { AUTHORING_UNLOCK_WORK_PACKAGE_DEMAND } from "authoring/lib/constants/authoring-permissions.mjs"
import { unlockProjectFromLegacy } from "../controller/unlock-project-from-legacy"
import { UnlockWorkPackageDialog } from "../components/unlock-work-package-dialog"

export function UnlockWorkPackageButton() {
    const { target: project } = useBoundContext()
    const canUnlock = useDemand(AUTHORING_UNLOCK_WORK_PACKAGE_DEMAND)

    const scheduleCount = project?.scopedScheduleIds?.length ?? 0
    const unlockDialog = useDialog(<UnlockWorkPackageDialog scheduleCount={scheduleCount} />)

    if (!canUnlock) return null
    if (project?.archived) return null
    if (project?.phase !== ProjectPhase.PUSHED_TO_LEGACY) return null

    return (
        <Button
            data-cy="unlock-work-package-button"
            startIcon={<Iconify icon={"material-symbols:lock-open-outline"} />}
            variant="outlined"
            onClick={handleClick}
        >
            Unlock
        </Button>
    )

    async function handleClick() {
        const confirmed = await unlockDialog()
        if (!confirmed) return

        const result = await unlockProjectFromLegacy({ projectId: project?.id })
        if (!result?.success) {
            errorSnackbar(result?.error || "Failed to unlock work package")
            return
        }

        const restored = result.restoredDraftCount ?? 0
        const detail = restored ? `${restored} ${restored === 1 ? "draft" : "drafts"} returned to editing` : null
        successSnackbar(detail ? `Work package unlocked — ${detail}` : "Work package unlocked")
    }
}
